/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { LuisText, LuisTextProps } from 'src/core/components/LuisText';

export const TestPaneSectionLabel = (props: LuisTextProps) => <LuisText lineHeight="20px" fontWeight="bold" {...props} />;
